import { render, staticRenderFns } from "./DashboardTechnician.vue?vue&type=template&id=d2873c08&"
import script from "./DashboardTechnician.vue?vue&type=script&lang=js&"
export * from "./DashboardTechnician.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTechnician.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports